// import { Icon } from '@iconify/react';
// import androidFilled from '@iconify/icons-ant-design/android-filled';
// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material'; 
// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  margin: theme.spacing(1),
  color: theme.palette.primary.darker,
  backgroundColor: theme.palette.primary.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.primary.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0)} 0%, ${alpha(
    theme.palette.primary.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------
 

export default function AppCard(props) {
  return (
    <RootStyle style={{background:props.background}} >{/* style={{backgroundColor:props.backgroundColor}} */}
      <IconWrapperStyle>
        {props.Icon}
        {/* <Icon icon={Category} width={24} height={24} /> */}
      </IconWrapperStyle>
      <Typography variant="h3">{props.value}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        {props.Text}
      </Typography>
    </RootStyle>
  );
}
